var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58364",
    "data-name": "Group 58364",
    transform: "translate(-1265 -111)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7929",
    "data-name": "Rectangle 7929",
    transform: "translate(1265 111)",
    fill: "#fff",
    stroke: "#eff1f5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58363",
    "data-name": "Group 58363",
    transform: "translate(-18.155 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M10.544.5l.667.667a1.718,1.718,0,0,1,0,2.43L7.094,7.718a1.592,1.592,0,0,1-1.132.469H3.907A.412.412,0,0,1,3.5,7.765l.052-2.072A1.6,1.6,0,0,1,4.016,4.6h0L8.114.5A1.722,1.722,0,0,1,10.544.5ZM8.7,1.084l-.338.337,1.934,1.935.338-.337a.9.9,0,0,0,0-1.267l-.667-.667A.9.9,0,0,0,8.7,1.084Z",
    transform: "translate(1294.088 119)",
    fill: "#1b2737",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M3.76-.226H6.2a.74.74,0,0,1,0,1.48H3.76a2.452,2.452,0,0,0-1.841.724A2.808,2.808,0,0,0,1.23,3.951V9.385a2.808,2.808,0,0,0,.688,1.973,2.452,2.452,0,0,0,1.841.724H9.527a2.453,2.453,0,0,0,1.842-.724,2.807,2.807,0,0,0,.689-1.973V6.752a.74.74,0,0,1,1.48,0V9.385A4.255,4.255,0,0,1,12.431,12.4a3.905,3.905,0,0,1-2.9,1.16H3.76a3.9,3.9,0,0,1-2.9-1.16A4.256,4.256,0,0,1-.25,9.385V3.951A4.256,4.256,0,0,1,.856.934,3.9,3.9,0,0,1,3.76-.226Z",
    transform: "translate(1292.512 119)",
    fill: "#1b2737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.69fd14c006953d47001b2513775cb201.svg";
export { ForwardRef as ReactComponent };